const LEGACY_APP_URL =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:3000"
    : "https://emma.adalab.es";

export { LEGACY_APP_URL };
